import 'babel-polyfill';
import { applyMiddleware, compose, createStore as createReduxStore } from 'redux';
import promise from 'redux-promise-middleware';
import createSagaMiddleware from 'redux-saga';
import { browserHistory } from 'react-router';
import { I18n } from 'react-i18nify';
import locales from 'locales/locales';
import reducers from './reducers';
import { updateLocation } from './location';

const createStore = (initialState = {}) => {
  // ======================================================
  // Middleware Configuration
  // ======================================================
  const sagaMiddleware = createSagaMiddleware();

  // ======================================================
  // Store Enhancers
  // ======================================================
  let composeEnhancers = compose;

  if (__DEV__) {
    if (typeof window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ === 'function') {
      composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__;
    }
  }

  // ======================================================
  // Store Instantiation and HMR Setup
  // ======================================================
  const store = createReduxStore(
    reducers(),
    initialState,
    composeEnhancers(
      applyMiddleware(promise(), sagaMiddleware),
    ),
  );

  store.asyncReducers = {};
  store.asyncSagas = {};
  store.runSaga = (saga) => {
    sagaMiddleware.run(saga);
  };

  I18n.setTranslations(locales);
  I18n.setLocale('hu');

  store.unsubscribeHistory = browserHistory.listen(updateLocation(store));

  if (module.hot) {
    module.hot.accept('./reducers', () => {
      store.replaceReducer(reducers(store.asyncReducers));
    });
  }

  return store;
};

// export const host = 'https://jelentkezes.reformatus.hu/api';
export const host = 'https://rkkk.devzone.info/api';
export default createStore;



// WEBPACK FOOTER //
// /Users/balazskaxd/dev/rkk/rkk-webapp/src/store/createStore.js